import { cn } from '~/lib/utils';
import notionIcon from '~/landing_page/Assets/Notion.png';
import styles from './WidgetCard.module.css';

export interface NotionCardProps {
  className?: string;
  title?: string;
  text?: string;
}

export const NotionCard = ({
  className,
  title = 'Sprint 34',
  text = 'Good sprint overall. We shipped the auth redesign but the API timeout issue is still open. Here\'...',
}: NotionCardProps) => {
  return (
    <div className={cn(styles.card, className)}>
      <div className={styles.row}>
        <img src={notionIcon} className={styles.icon} alt="Notion" />
        <div className={styles.body}>
          <p className={styles.title}>{title}</p>
          <p className={cn(styles.text, styles.textClamp3)}>{text}</p>
        </div>
      </div>
    </div>
  );
};

NotionCard.displayName = 'NotionCard';
